import * as React from "react"
import { X } from "lucide-react"

import { cn } from "@/lib/utils"
import { Alert, AlertDescription, AlertTitle } from "./Alert"
import { Button } from "./button"

export interface ViewAsOrgBannerProps {
  organization: {
    id: string
    name: string
  }
  onStopViewing: () => void
  className?: string
}

const ViewAsOrgBanner = React.forwardRef<
  HTMLDivElement,
  ViewAsOrgBannerProps
>(({ organization, onStopViewing, className }, ref) => {
  return (
    <Alert
      ref={ref}
      className={cn(
        "border-accent-blue/50 bg-accent-blue/10 text-accent-blue",
        className
      )}
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex-1">
          <AlertTitle className="mb-1">Viewing as Organization</AlertTitle>
          <AlertDescription className="text-accent-blue">
            You are currently viewing as <strong>{organization.name}</strong>. Actions you perform will be in the context of this organization.
          </AlertDescription>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onStopViewing}
          className="shrink-0 hover:bg-accent-blue/20"
          aria-label="Stop viewing as organization"
        >
          <X className="h-4 w-4" />
          Stop Viewing
        </Button>
      </div>
    </Alert>
  )
})
ViewAsOrgBanner.displayName = "ViewAsOrgBanner"

export { ViewAsOrgBanner }
